import {
    MdAddCircleOutline,
    MdCalendarToday,
    MdGroup,
    MdList,
    MdOutlineGroup,
} from 'react-icons/md';

const lfpNavigation = [
    {
        id: 'new_lfp_referrals',
        title: 'New Referrals',
        icon: <MdOutlineGroup size={20} />,
        navLink: '/new_lfp_referrals',
        action: 'read',
        resource: 'lfp_lawyer_referrals',
    },
    {
        id: 'lfp_lawyer_leads',
        title: 'Leads',
        icon: <MdAddCircleOutline size={20} />,
        navLink: '/lfp_lawyer_leads',
        action: 'read',
        resource: 'lfp_lawyer_referrals',
    },
    {
        id: 'lfp_lawyer_matters',
        title: 'Matters',
        icon: <MdList size={20} />,
        navLink: '/lfp_lawyer_matters',
        action: 'read',
        resource: 'lfp_lawyer_referrals',
    },
    {
        id: 'lfp_appointments',
        title: 'Appointments',
        icon: <MdCalendarToday size={20} />,
        navLink: '/lfp_appointments',
        action: 'read',
        resource: 'lfp_appointments',
    },
    {
        id: 'lfp_contacts',
        title: 'Contacts',
        icon: <MdGroup size={20} />,
        navLink: '/lfp_contacts',
        action: 'read',
        resource: 'lfp_contacts',
    },
];

export default lfpNavigation;
